import * as SliderRadix from '@radix-ui/react-slider';
import './slider.css';

interface ISliderProps {
  step: number;
  max: number;
  min: number;
  defaultValue: number;
  value: number;
  onChange: (value: number) => void;
}

const Slider = ({
  step,
  max,
  min,
  defaultValue,
  value,
  onChange,
}: ISliderProps) => (
  <form>
    <SliderRadix.Root
      className="SliderRoot"
      defaultValue={[defaultValue]}
      max={max}
      min={min}
      step={step}
      value={[value]}
      onValueChange={(value) => onChange(Number(value[0]))}
    >
      <SliderRadix.Track className="SliderTrack">
        <SliderRadix.Range className="SliderRange" />
      </SliderRadix.Track>
      <SliderRadix.Thumb className="SliderThumb" aria-label="Volume" />
    </SliderRadix.Root>
  </form>
);

export default Slider;
